import { TourPoints } from "./Tour";

export type TourDriverRecord = {
  driverId: string;
  position: number | undefined;
  totalPoints: number | "Qual";
  tournamentPoints: { [tournamentId: string]: number | "Qual" };
};

export type TourDriverRecordWithDisplay = {
  record: TourDriverRecord;
  orgId: string | undefined;
  orgName: string | undefined;
  displayName: string;
};
const createTourDriverRecord = (driverId: string): TourDriverRecord => {
  return {
    driverId,
    position: undefined,
    totalPoints: 0,
    tournamentPoints: {},
  };
};

// temp code
const getSmsPoints = (driverId: string, points: TourPoints) =>
  points.overrides?.["Smsx1"]?.[driverId] ?? 0;

const getAmPoints = (driverId: string, points: TourPoints) =>
  points.overrides?.["AmericasMastersx1"]?.[driverId] ?? 0;

const getCcbPoints = (driverId: string, points: TourPoints) =>
  points.overrides?.["Ccb2025"]?.[driverId] ?? 0;

const getOmniumPoints = (driverId: string, points: TourPoints) =>
  points.overrides?.["OmniumTeamsx1"]?.[driverId] ?? 0;

const getGlacialDuoPoints = (driverId: string, points: TourPoints) =>
  points.overrides?.["GlacialMixDuox1"]?.[driverId] ?? 0;

export const calculateTourDriverRecords = (
  driverIds: string[],
  points: TourPoints
) => {
  const records = new Map<string, TourDriverRecord>();
  driverIds.forEach((id) => {
    const record = createTourDriverRecord(id);
    record.tournamentPoints["Smsx1"] = getSmsPoints(id, points);
    record.tournamentPoints["AmericasMastersx1"] = getAmPoints(id, points);
    record.tournamentPoints["Ccb2025"] = getCcbPoints(id, points);
    record.tournamentPoints["OmniumTeamsx1"] = getOmniumPoints(id, points);
    record.tournamentPoints["GlacialMixDuox1"] = getGlacialDuoPoints(
      id,
      points
    );
    record.totalPoints = getTotalPoints(record);
    records.set(id, record);
  });

  const sortedRecords = Array.from(records.values()).sort(compareRecords);
  if (sortedRecords.length === 0 || sortedRecords[0].totalPoints === 0) {
    return sortedRecords;
  }

  sortedRecords[0].position = 1;
  for (let i = 1; i < sortedRecords.length; i++) {
    if (compareRecords(sortedRecords[i - 1], sortedRecords[i]) === 0) {
      sortedRecords[i].position = sortedRecords[i - 1].position;
    } else {
      sortedRecords[i].position = i + 1;
    }
  }

  return sortedRecords;
};

const getTotalPoints = (record: TourDriverRecord) => {
  const tournamentPoints = Object.values(record.tournamentPoints);
  if (tournamentPoints.some((t) => t === "Qual")) {
    return "Qual";
  }

  // todo - can maybe remove this cast if TS version updated
  return (tournamentPoints as number[]).reduce((a, b) => a + b, 0);
};

const compareRecords = (a: TourDriverRecord, b: TourDriverRecord): number => {
  if (a.totalPoints === b.totalPoints) {
    return 0;
  }

  if (a.totalPoints === "Qual") {
    return -1;
  }

  if (b.totalPoints === "Qual") {
    return 1;
  }

  return b.totalPoints - a.totalPoints;
};
